export default __webpack_public_path__ + "static/media/durvis-10-min.00df732c.jpg";